import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectSelectedTenantId } from "../store/user/selectors";
import { getTeamsByTenant } from "../store/team/thunks";
import { selectTeamState } from "../store/team/selectors";

export const useTenantTeams = () => {
  const dispatch = useDispatch();
  const selectedTenantId = useSelector(selectSelectedTenantId);
  const { teamsByTenant, loading } = useSelector(selectTeamState);

  useEffect(() => {
    if (selectedTenantId && !teamsByTenant[selectedTenantId]) {
      dispatch(getTeamsByTenant({ tenant_id: selectedTenantId }));
    }
  }, [selectedTenantId, teamsByTenant, dispatch]);

  const { teams } = useMemo(() => {
    return {
      teams: teamsByTenant[selectedTenantId] || [],
    };
  }, [teamsByTenant, selectedTenantId]);

  return { teams, loading, selectedTenantId };
};
